import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  transition: 0.3s, 0s box-shadow, 0s border-radius;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var Icon = styled.span.withConfig({
    componentId: "sc-43c329ad-0"
})(_templateObject());
export var IconArrow = function() {
    return /*#__PURE__*/ _jsx(Icon, {
        children: /*#__PURE__*/ _jsx("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M5.29289 3.29289C5.68342 2.90237 6.31658 2.90237 6.70711 3.29289C7.09763 3.68342 7.09763 4.31658 6.70711 4.70711L4.41421 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H4.41421L6.70711 11.2929C7.09763 11.6834 7.09763 12.3166 6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071L0.585787 8L5.29289 3.29289Z",
                fill: "#050038"
            })
        })
    });
};
export var IconOpen = function() {
    return /*#__PURE__*/ _jsx(Icon, {
        children: /*#__PURE__*/ _jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24",
            className: "icon-1o_Rf icon_large-2Zr5i",
            "aria-hidden": "true",
            role: "presentation",
            focusable: "false",
            "data-testid": "svg-icon",
            children: /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M17.586 5H15a1 1 0 0 1 0-2h6v6a1 1 0 0 1-2 0V6.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L17.586 5zM6.414 19H9a1 1 0 0 1 0 2H3v-6a1 1 0 0 1 2 0v2.586l3.293-3.293a1 1 0 1 1 1.414 1.414L6.414 19z"
            })
        })
    });
};
export var IconClose = function() {
    return /*#__PURE__*/ _jsx(Icon, {
        children: /*#__PURE__*/ _jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24",
            className: "icon-1o_Rf icon_large-2Zr5i",
            "aria-hidden": "true",
            role: "presentation",
            focusable: "false",
            "data-testid": "svg-icon",
            children: /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M7.586 15H5a1 1 0 0 1 0-2h6v6a1 1 0 0 1-2 0v-2.586l-4.293 4.293a1 1 0 1 1-1.414-1.414L7.586 15zm8.828-6H19a1 1 0 0 1 0 2h-6V5a1 1 0 0 1 2 0v2.586l4.293-4.293a1 1 0 0 1 1.414 1.414L16.414 9z"
            })
        })
    });
};
